/**
 * Normalisation du contexte d'identité (B1, issue #29).
 *
 * Convertit la réponse de GET /api/v1/users/me en CurrentUser exploitable :
 * le backend renvoie les IDs métier absents sous forme de chaîne vide,
 * ce module les transforme en undefined pour éviter d'envoyer '' aux APIs.
 *
 * @module lib/auth
 */

import type { CurrentUser, CurrentUserResponse } from './types';

function blankToUndefined(value: string | undefined | null): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function normalizeCurrentUser(raw: CurrentUserResponse): CurrentUser {
  return {
    id: raw.id,
    email: raw.email ?? '',
    firstName: raw.firstName ?? '',
    lastName: raw.lastName ?? '',
    role: raw.role,
    roleLabel: raw.roleLabel ?? raw.role,
    practitionerProfileId: blankToUndefined(raw.practitionerProfileId),
    patientId: blankToUndefined(raw.patientId),
    centerId: blankToUndefined(raw.centerId),
    secretaryProfileId: blankToUndefined(raw.secretaryProfileId),
  };
}
